/*
 * File: /src/services/leadSourceDetailService.js
 * Created Date: Tuesday December 14th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 14th December 2021 3:46:57 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_LEAD_SOURCE_DETAIL_PATH } from '../constants';

export default {
  fetchAll() {
    return authedAxios.get(AD_BASE_LEAD_SOURCE_DETAIL_PATH);
  },
  fetchById(id) {
    return authedAxios.get(AD_BASE_LEAD_SOURCE_DETAIL_PATH + id);
  },
  updateLeadSourceDetail(id, payload) {
    return authedAxios.put(AD_BASE_LEAD_SOURCE_DETAIL_PATH + id, payload);
  },
  createLeadSourceDetail(payload) {
    return authedAxios.post(AD_BASE_LEAD_SOURCE_DETAIL_PATH, payload);
  }
};
